module.exports = "/assets/e284aa4a30238437856fd503f582e252.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/PZ.png
// module id = 2858
// module chunks = 0